var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWallet2 = function SvgWallet2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#787473",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8.667 6h-4M14.667 7.313v1.374a.684.684 0 0 1-.667.68h-1.307c-.72 0-1.38-.527-1.44-1.247-.04-.42.12-.813.4-1.087.247-.253.587-.4.96-.4H14a.684.684 0 0 1 .666.68"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#787473",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M11.653 7.033c-.28.274-.44.667-.4 1.087.06.72.72 1.247 1.44 1.247H14v.966c0 2-1.334 3.334-3.334 3.334h-6c-2 0-3.333-1.334-3.333-3.334V5.667c0-1.814 1.093-3.08 2.793-3.294q.261-.04.54-.04h6c.174 0 .34.007.5.034 1.72.2 2.834 1.473 2.834 3.3v.966h-1.387c-.373 0-.713.147-.96.4"
  })));
};
export default SvgWallet2;